import axios from "axios";
import { SubscribeRequest, SubscribeResponse } from "./newsletterApi.types";

const baseUrl = "/api/newsletter";
const subscribeUrl = `${baseUrl}/subscribe`;

export const postSubscribe = async (
  requestData: SubscribeRequest
): Promise<SubscribeResponse> => {
  const response = await axios.post<SubscribeResponse>(
    subscribeUrl,
    requestData
  );

  return response.data;
};
